import { useState } from 'react';

export default function ChatBookingCallout() {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleChatClick = () => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 600);
    
    // Trigger the Readdy Agent chat widget
    const chatButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (chatButton) {
      chatButton.click();
    }
  };

  return (
    <div className="bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-200 rounded-lg p-6 shadow-sm">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-gradient-to-br from-[#D97642] to-[#c96532] rounded-full flex items-center justify-center shadow-md">
            <i className="ri-chat-smile-3-line text-white text-2xl"></i>
          </div>
        </div>
        
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-[#1A3A52] mb-2 flex items-center gap-2">
            Book Instantly via Chat
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-[#D97642] text-white">
              New
            </span>
          </h3>
          
          <p className="text-gray-700 text-sm mb-4 leading-relaxed">
            Skip the form! Click the chat icon in the bottom-right corner and simply type 
            <strong className="text-[#1A3A52]"> "Book an appointment"</strong> to schedule your free consultation instantly. 
            Our AI assistant will guide you through the process in seconds.
          </p>
          
          <button
            onClick={handleChatClick}
            className={`inline-flex items-center gap-2 px-5 py-2.5 bg-[#1A3A52] text-white rounded-lg font-medium text-sm hover:bg-[#2a4a62] transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap ${
              isAnimating ? 'scale-95' : 'scale-100'
            }`}
          >
            <i className="ri-message-3-line text-lg"></i>
            Chat to Book Now
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
          
          <div className="mt-3 flex items-center gap-2 text-xs text-gray-600">
            <i className="ri-time-line text-[#D97642]"></i>
            <span>Available 24/7 • Instant responses</span>
          </div>
        </div>
      </div>
      
      {/* Animated pointer hint */}
      <div className="mt-4 pt-4 border-t border-orange-200">
        <div className="flex items-center gap-2 text-xs text-gray-600">
          <i className="ri-arrow-down-line text-[#D97642] animate-bounce"></i>
          <span className="italic">Look for the chat button in the bottom-right corner of your screen</span>
        </div>
      </div>
    </div>
  );
}